import { ToolType, type ToolPostPayload } from "@repo/app-types/entities/tool";
import type { FC } from "react";
import { Dialog } from "react-aria-components";
import { twMerge } from "tailwind-merge";
import { ToolFormActions } from "./components/toolFormActions.js";
import { useToolForm } from "./hooks/useToolForm.js";

export interface CreateToolModalDialogProps {
  type: ToolType;
  onSave: (data: ToolPostPayload) => Promise<void>;
}

export const CreateToolModalDialog: FC<CreateToolModalDialogProps> = (
  props,
) => {
  const isWide = props.type === ToolType.CUSTOM || props.type === ToolType.CODE;

  const {
    isEditMode,
    isFormValid,
    hasChanges,
    isSaving,
    onSave,
    onDiscard,
    renderForm,
  } = useToolForm({
    type: props.type,
    onSave: props.onSave,
  });

  return (
    <Dialog
      className={twMerge(
        "mt-4 flex flex-col gap-3",
        isWide ? "w-[700px]" : "w-[500px]",
      )}
    >
      {({ close }) => (
        <>
          {renderForm()}

          <ToolFormActions
            isEditMode={isEditMode}
            hasChanges={hasChanges}
            isFormValid={isFormValid}
            isSaving={isSaving}
            onSave={onSave}
            onDiscard={onDiscard}
            onCancel={close}
          />
        </>
      )}
    </Dialog>
  );
};
